import React, { useState } from "react";

const NewsLetterForm = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Define the API endpoint
    const apiEndpoint = `users/Subscribe`;
    const apiUrl = process.env.REACT_APP_API_BASE_URL + apiEndpoint;

    // Basic email validation
    if (!email.trim()) {
      setError("Email address is required");
      return;
    }

    if (!/^\S+@\S+\.\S+$/.test(email)) {
      setError("Invalid email address");
      return;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
        }),
      });

      const data = await response.json();

      if (response.status === 200) {
        // Successful API call
        setSuccessMessage(data.message);

        // Clear the error state when there is a success message
        setError("");
      } else {
        // Handle error from the server
        setError(data.message);
      }
    } catch (error) {
      console.error("Error:", error);
      setError("An error occurred while processing your request.");
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button className="ripple-btn tran3s" type="submit">
          Subscribe
        </button>
      </form>
      {error && (
        <p style={{ color: "red", fontSize: "15px", fontWeight: "bold" }}>
          {error}
        </p>
      )}
      {successMessage && (
        <p style={{ color: "green", fontSize: "15px", fontWeight: "bold" }}>
          {successMessage}
        </p>
      )}
    </>
  );
};

export default NewsLetterForm;
